<script>
    export default {
        render: () => null,
        name: "ColorFeature",
        props: ["volume", "meshMaterial"],
        
        data() {
            return {
                animation: null,
                meshID: null
            }
        },

        computed: {
            color: function () {
                return this.volume.isHighlighted;
            },

            yellowHighlight: function() {
                return this.volume.isYellowHighlighted;
            }
        },

        methods: {
            updateDeltaValueForTransition: function (deltaValue) {

                this.meshMaterial.forEach((material) => {
                    const index = this.meshID - material.uniforms.meshIdOffset.value;
                    material.uniforms.highlightTransitionTexture.value.image.data[Math.floor(index)] = deltaValue;
                    material.uniforms.highlightTransitionTexture.value.needsUpdate = true;
                });

            },
        },

        watch: {
            color: function (isHighlighted, isPreviouslyHighlighted) {
                if (this.animation) {
                    this.animation.stop();
                }

                const current = {
                    value: isHighlighted ? 0.0: 1.0
                };
                const target = {
                    value: isHighlighted ? 1.0: 0.0
                };
                this.meshID = modelManager.getVolume(this.volume.branchID).meshID;

                VolumeOpacity.restoreVolumeTransparency(this.volume.branchID, this.volume.modelId, !isHighlighted);

                let animationDuration = this.volume.animationDuration;
                if (wv.effectController.yellowHighlight && isPreviouslyHighlighted && !isHighlighted) {
                    animationDuration = 0;
                }

                this.animation = new TWEEN.Tween(current)
                    .to(target, animationDuration)
                    .onUpdate(() => this.updateDeltaValueForTransition(current.value))
                    .onComplete(onComplete)
                    .onStop(onComplete)
                    .start();

                let self = this;
                function onComplete() {
                    self.updateDeltaValueForTransition(self.volume.isHighlighted ? 1.0: 0.0);
                    self.animation = null;
                }
            },
            yellowHighlight: function (isHighlighted) {
                if (this.animation) {
                    this.animation.stop();
                }

                const current = {
                    value: isHighlighted ? 0.0: -1.0
                };
                const target = {
                    value: isHighlighted ? -1.0: 0.0
                };
                this.meshID = modelManager.getVolume(this.volume.branchID).meshID;

                VolumeOpacity.restoreVolumeTransparency(this.volume.branchID, this.volume.modelId, !isHighlighted);

                this.animation = new TWEEN.Tween(current)
                    .to(target, this.volume.animationDuration)
                    .onUpdate(() => this.updateDeltaValueForTransition(current.value))
                    .onComplete(onComplete)
                    .onStop(onComplete)
                    .start();

                let self = this;
                function onComplete() {
                    self.updateDeltaValueForTransition(self.volume.isYellowHighlighted ? -1.0: 0.0);
                    self.animation = null;
                }
            }
        }
    }
</script>
